import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppInnerWrapper } from '@rsos/components/capstone/Layout/AdminLayout/AdminLayout.styles';
import SectionGate from '../../../app/SectionGate';
import initialize from '../actions/initialize';

const useInitialize = dispatch => {
  useEffect(() => {
    (async () => {
      const action = await dispatch(initialize());
      if (action && action.error) {
        throw new Error(action.error);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

// Init gate for the psap-management section. Acts as a route layout:
// the section's page lives in the consolidated route table (app/Main.tsx) and
// renders through the <Outlet /> that SectionGate provides once initialized.
const App = () => {
  const dispatch = useDispatch();
  const { initializing, initialized, error } = useSelector(
    state => state.appPsap,
  );
  useInitialize(dispatch);

  return (
    <SectionGate
      initializing={initializing}
      initialized={initialized}
      hasError={!!error}
      wrapper={AppInnerWrapper}
    />
  );
};

export default App;
